import React from 'react';
import HtmlContent from '../../../components-legacy/HtmlContent';
import useScrollRestoration from '../../../hooks/useScrollRestoration';
import Distance from '../../../styled/Distance';
import { H2 } from '../../../styled/Heading';
import ArticleCount from '../../pages/CategoryPage/ArticleCount';
import LoadMore from '../../pages/CategoryPage/LoadMore';
import Products from '../../pages/CategoryPage/Products';
import CategoryProvider from '../../pages/CategoryPage/Providers/CategoryProvider';
import { ProductsViewContainer, ProductsWrapper } from '../../../styled/ProductGrid/wrappers';
import ViewSettings from '../../pages/CategoryPage/ViewSettings';
import { ViewSettingsProvider } from '../../pages/CategoryPage/Providers/ViewSettingsProvider';
import Container from '../../../styled/Container';

export interface IProductListingSlice {
  baseQuery?: string;
  categoryId: string;
  filters?: IFilters;
  preamble: string;
  searchResult: {
    totalHits: number;
    nextPage: number;
    availableFilters: IAvailableFilter[];
    products: IProduct[];
    errors: Record<string, string>;
  };
  showFilters: boolean;
  sorting: Sorting;
  title: string;
  titleHeadingLevel?: number;
}

const ProductListingSlice = ({
  baseQuery,
  categoryId,
  filters,
  preamble,
  searchResult,
  showFilters,
  sorting,
  title,
  titleHeadingLevel,
}: IProductListingSlice) => {
  const { availableFilters, totalHits, nextPage, products, errors } = searchResult || {};

  useScrollRestoration(`campaign-rewards-page-${baseQuery}`);
  return (
    <ProductsWrapper className="accent-wrapper">
      <ProductsViewContainer>
        <Container>
          <H2 as={titleHeadingLevel === 1 ? 'h1' : undefined}>{title}</H2>
          <Distance size={['2', '2']} />
          <HtmlContent html={preamble} />
          <Distance size={['3', '5']} />
        </Container>

        {!!products && (
          <CategoryProvider
            baseQuery={baseQuery}
            totalHits={totalHits}
            availableFilters={availableFilters}
            filters={filters}
            nextPage={nextPage}
            products={products}
            id={categoryId}
            sort={sorting}
            errors={errors}>
            <ViewSettingsProvider>
              <Container>
                <ViewSettings showFilters={showFilters} />
              </Container>
              <Distance size="2" />
              <Products />
              {showFilters && (
                <>
                  <Distance size={['2', '5']} />
                  <ArticleCount />
                </>
              )}
              <Distance size={['2', '5']} />

              <Container>
                <LoadMore />
              </Container>

              <Distance size={['2', '5']} />
            </ViewSettingsProvider>
          </CategoryProvider>
        )}
      </ProductsViewContainer>
    </ProductsWrapper>
  );
};

export default ProductListingSlice;
